import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-missing-alt',
    templateUrl: './missing-alt.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoMissingAltComponent {
}
